import { LatLong } from 'data/models/ZoneCoordinates';

export type GeoJSONPositionData = [number, number];
export type GeoJSONPositionOptions = GeoJSONPositionData;

export class GeoJSONPosition extends LatLong {
    static fromGeoJSONData([lon, lat] : GeoJSONPositionData) {
        return new GeoJSONPosition(lat, lon);
    }
}



// WEBPACK FOOTER //
// ./data/models/GeoJSONPosition.ts